import { IoCheckmarkCircleSharp } from "react-icons/io5";

function RegSuccess() {
  return (
    <div className="reg__form-container">
      <div className="container spaceTop">
        <div className="reg__success">
          <IoCheckmarkCircleSharp className="reg__success-img" />
          <h2>Congratulations!</h2>
          <p>Your Application is completed. An email has been sent to you with details on the next step.</p>
          <p>If you did not recieve an email, kindly login for access</p>
          <a href="https://portal.reworkacademy.co">Proceed to Portal</a>
        </div>
      </div>
    </div>
  );
}

export default RegSuccess;
